import { AssetType, NodeType, Service } from "../types";
import { getAssetTypeFromAppId } from "./getAssetTypeFromAppId";

export function determineAssetType(
  selectedApps: Service[] | undefined,
  nodeType: NodeType,
): AssetType {
  if (nodeType === "zap") {
    return "zap";
  }

  const appId = selectedApps?.[0]?.currentImplementation?.id ?? "";
  return getAssetTypeFromAppId(appId);
}
